// Simple Firebase connection test
import { auth, db } from './firebase.js';
import { connectAuthEmulator } from 'firebase/auth';
import { connectFirestoreEmulator } from 'firebase/firestore';

export const testFirebaseConnection = () => {
  console.log('🔥 Testing Firebase connection...');
  
  // Test Auth connection
  if (auth) {
    console.log('✅ Firebase Auth initialized successfully');
    console.log('Auth domain:', auth.app.options.authDomain);
  } else {
    console.error('❌ Firebase Auth failed to initialize');
  }
  
  // Test Firestore connection
  if (db) {
    console.log('✅ Firebase Firestore initialized successfully');
    console.log('Project ID:', db.app.options.projectId);
  } else {
    console.error('❌ Firebase Firestore failed to initialize');
  }
  
  // Check environment variables
  const requiredEnvVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_STORAGE_BUCKET',
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
    'VITE_FIREBASE_APP_ID'
  ];
  
  const missingVars = requiredEnvVars.filter(varName => !import.meta.env[varName]);
  
  if (missingVars.length > 0) {
    console.warn('⚠️ Missing environment variables:', missingVars);
    console.log('Please check your .env.local file');
  } else {
    console.log('✅ All required environment variables are set');
  }
  
  return {
    authConnected: !!auth,
    dbConnected: !!db,
    envVarsComplete: missingVars.length === 0
  };
};
